import { MaskedTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { Row, Col } from 'react-bootstrap';

type IpaAdministrationWizardMsoDetailsProps = {
    register: any;
    mso: Record<string, any>;
};

const IpaAdministrationWizardMsoDetails = (props: IpaAdministrationWizardMsoDetailsProps) => {
    return (
        <div className='accordion-content'>
            <Row>
                <Col md={4}>
                    <div className={`e-float-input e-input-group e-input-group-margin disable-field`}>
                        <input
                            type='text'
                            {...props?.register('msoName')}
                            value={props?.mso?.name}
                        />
                        <label className='e-float-text'>MSO Name</label>
                    </div>
                </Col>

                <Col md={4}>
                    <div className={`e-float-input e-input-group e-input-group-margin disable-field`}>
                        <input
                            type='text'
                            {...props?.register('msoAddress1')}
                            value={props?.mso?.address1}
                        />
                        <span className='e-float-line'></span>
                        <label className='e-float-text'>Address</label>
                    </div>
                </Col>

                <Col md={4}>
                    <div className={`e-float-input e-input-group e-input-group-margin disable-field`}>
                        <input
                            type='text'
                            {...props?.register('msoAddress2')}
                            defaultValue={props?.mso?.address2}
                        />
                        <span className='e-float-line'></span>
                        <label className='e-float-text'>Suite/Bldg/No</label>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col md={4}>
                    <div className={`e-float-input e-input-group e-input-group-margin disable-field`}>
                        <input
                            type='text'
                            {...props?.register('msoCity')}
                            defaultValue={props?.mso?.city}
                        />
                        <span className='e-float-line'></span>
                        <label className='e-float-text'>City</label>
                    </div>
                </Col>
                <Col md={4}>
                    <div className={`e-float-input e-input-group e-input-group-margin disable-field`}>
                        <input
                            type='text'
                            {...props?.register('msoState')}
                            defaultValue={props?.mso?.state}
                        />
                        <span className='e-float-line'></span>
                        <label className='e-float-text'>State</label>
                    </div>
                </Col>
                <Col md={4}>
                    <div className={`e-float-input e-input-group e-input-group-margin disable-field`}>
                        <input
                            type='text'
                            {...props?.register('msoZipCode')}
                            defaultValue={props?.mso?.zipCode}
                        />
                        <span className='e-float-line'></span>
                        <label className='e-float-text'>Zip</label>
                    </div>
                </Col>
            </Row>

            <Row>
                <Col md={4}>
                    <div className='e-input-group-margin'>
                        <label className='e-label-select'>Phone / Fax</label>
                        <MaskedTextBoxComponent
                            mask='(000) 000-0000'
                            {...props?.register('msoPhone')}
                            value={props?.mso?.phone}
                            readOnly={true}
                        />
                        <span className='e-float-line'></span>
                    </div>
                </Col>

                <Col md={4}>
                    <div className={`e-float-input e-input-group e-input-group-margin disable-field col-md-4`}>
                        <input
                            type='text'
                            {...props?.register('msoEmail')}
                            defaultValue={props?.mso?.email}
                        />
                        <span className='e-float-line'></span>
                        <label className='e-float-text'>Email</label>
                    </div>
                </Col>

                <Col md={4}>
                    <div className={`e-float-input e-input-group e-input-group-margin disable-field col-md-4`}>
                        <input
                            type='text'
                            {...props?.register('msoNotes')}
                            defaultValue={props?.mso?.notes}
                        />
                        <span className='e-float-line'></span>
                        <label className='e-float-text'>Notes</label>
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default IpaAdministrationWizardMsoDetails;
